import React from 'react'

import uiStore from '../../../utils/UIStore'
import { isMobileDevice } from '../../../utils/responsiveUtils'

import FormHomePage from '../../FormHomePage'

import SkewComponent from '../SkewComponent'
import MobilePriceCards from '../PriceCards/index.mobile'
import MobileBookNowButton from '../MobileBookNowButton'

import {
  MobileSectionContainer,
  ResponsiveContainer,
  SectionContainer,
  IBCLogo,
  HeadText,
  DescriptionText,
  NowatContent,
  DescriptionWrapper,
  VideoSectionContainer
} from './styledComponents'

class LandingMobile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      player: null
    }
  }

  onReady = event => {
    this.setState({
      player: event.target
    })
    this.state.player.playVideo()
  }

  pauseVideo = () => {
    if (this.state.player) {
      this.state.player.pauseVideo()
    }
  }

  onClickBookMySlot = () => {
    if (this.sbFormModalRef) {
      this.sbFormModalRef.openModal()
    }
  }

  captureSBFormModalRef = ref => {
    const { captureFormMobileRef } = this.props
    if (ref) {
      this.sbFormModalRef = ref
      captureFormMobileRef(ref)
      uiStore.setMobileSBFormModalRef(ref)
    }
  }

  render() {
    const {
      onFormSubmitSuccess,
      landingPageDetails,
      videoUrl,
      videoType,
      termsAndConditionsData,
      slotIdPrefix,
      arcadeFormMauticID,
      priceCardsData,
      arcadeCity,
      pagePrefix,
      excludeDates,
      bookingResponseData,
      amanoraSectionDetails,
      formData,
      isOnePlusOneOfferPresentInPriceCards
    } = this.props
    const landingPageDetailsObject = landingPageDetails
    return (
      <MobileSectionContainer>
        <ResponsiveContainer>
          <VideoSectionContainer>
            <video
              muted
              playsInline
              autoPlay
              loop
              poster={landingPageDetailsObject.mobilevideoposter}
              data-keepplaying
              id="mautic-player-0"
            >
              <source src={videoUrl} type={videoType} />
            </video>
          </VideoSectionContainer>
          {isMobileDevice() ? (
            <SectionContainer>
              <IBCLogo
                src={landingPageDetailsObject.logoimageurl}
                alt="iBC logo"
              />

              <HeadText as="p"> {landingPageDetailsObject.heading} </HeadText>
              <DescriptionWrapper>
                <DescriptionText
                  dangerouslySetInnerHTML={{
                    __html: landingPageDetailsObject.mobiledescription
                  }}
                  as="h1"
                />
                &nbsp;&nbsp;
                <NowatContent
                  dangerouslySetInnerHTML={{
                    __html: landingPageDetailsObject.nowatmobilecontent
                  }}
                />
                <SkewComponent
                  innerText={landingPageDetailsObject.skewsectioncontent}
                />
              </DescriptionWrapper>
            </SectionContainer>
          ) : null}
        </ResponsiveContainer>
        {priceCardsData && (
          <div>
            <MobilePriceCards
              priceCardsData={priceCardsData}
              openSBForm={this.onClickBookMySlot}
            />
            <MobileBookNowButton
              termsAndConditionsData={termsAndConditionsData}
              slotIdPrefix={slotIdPrefix}
              arcadeFormMauticID={arcadeFormMauticID}
              arcadeCity={arcadeCity}
              pagePrefix={pagePrefix}
              amanoraSectionDetails={amanoraSectionDetails}
              bookingResponseData={bookingResponseData}
              bookingInfo={formData}
              id="open-slot-booking-form"
            />
          </div>
        )}
        <FormHomePage
          ref={this.captureSBFormModalRef}
          onFormSubmitSuccess={onFormSubmitSuccess}
          termsAndConditionsData={termsAndConditionsData}
          slotIdPrefix={slotIdPrefix}
          arcadeFormMauticID={arcadeFormMauticID}
          arcadeCity={arcadeCity}
          pagePrefix={pagePrefix}
          priceCardsData={priceCardsData}
          excludeDates={excludeDates}
          isOnePlusOneOfferPresentInPriceCards={
            isOnePlusOneOfferPresentInPriceCards
          }
        />
      </MobileSectionContainer>
    )
  }
}

export default LandingMobile



// WEBPACK FOOTER //
// ./src/components/IbcArcade/LandingPage/index.mobile.js